import {
  CloudArrowUpIcon,
  CursorArrowRaysIcon,
  LockClosedIcon,
  ServerIcon,
  XCircleIcon
} from "@heroicons/react/20/solid";
import img from "../resource/pro/BBE_0724-22.jpg";
const features = [
  {
    name: "Choose Tier",
    description:
      "Let us know how many drinks you will want sent to you each month.",
    icon: CursorArrowRaysIcon,
  },
  {
    name: "Select Flavors",
    description:
      "Choose your favorite flavors or let us choose some. You can even change monthly!",
    icon: LockClosedIcon,
  },
  {
    name: "Submit Order Info with Saftey",
    description:
      "Monthly payments are secure by one of the leading payment gateways available. Trused by half a million merchants worldwide.",
    icon: ServerIcon,
  },
  {
    name: "Cancel at anytime",
    description:
      "Don't want to keep your subscription? No worries, we don't have any long term contracts or commitment. Cancel whenever you want!",
    icon: XCircleIcon,
  },
];

function Tutorial() {
  return (
    <div className="overflow-hidden bg-white py-24 sm:py-32">
      <div className="mx-auto max-w-7xl px-6 lg:px-8">
        <div className="mx-auto grid max-w-2xl grid-cols-1 gap-x-8 gap-y-16 sm:gap-y-20 lg:mx-0 lg:max-w-none lg:grid-cols-2">
          <div className="lg:pr-8 lg:pt-4">
            <div className="lg:max-w-lg">
              <h2 className="text-base font-semibold leading-7 text-indigo-600">
                Process
              </h2>
              <p className="mt-2 text-3xl font-bold tracking-tight text-gray-900 sm:text-4xl">
                How do they work?
              </p>
              <p className="mt-6 text-lg leading-8 text-gray-600">
                Getting your drinks has never been easier. With Big Blue
                Subscriptions, you can set up your monthly drink delivery in
                less than 5 minutes and never have to reorder again!
              </p>
              <dl className="mt-10 max-w-xl space-y-8 text-base leading-7 text-gray-600 lg:max-w-none">
                {features.map((feature) => (
                  <div key={feature.name} className="relative pl-9">
                    <dt className="inline font-semibold text-gray-900">
                      <feature.icon
                        className="absolute left-1 top-1 h-5 w-5 text-indigo-600"
                        aria-hidden="true"
                      />
                      {feature.name}
                    </dt>{" "}
                    <dd className="inline">{feature.description}</dd>
                  </div>
                ))}
              </dl>
            </div>
          </div>
          <img
            src={img}
            alt="Product screenshot"
            className="w-[48rem] max-w-none rounded-xl shadow-xl ring-1 ring-gray-400/10 sm:w-[57rem] md:-ml-4 lg:-ml-0"
            width={2432}
            height={1442}
          />
        </div>
      </div>
    </div>
  );
}
export default Tutorial;
